export const SET_MODAL = "modal:SET_MODAL";
export const UNSET_MODAL = "modal:UNSET_MODAL";
